import React from 'react';
import { Spinner as FluentuiSpinner, SpinnerSize } from '@fluentui/react';

export default function Spinner({ label }: { label: string }) {
  return (
    <FluentuiSpinner
      size={SpinnerSize.large}
      label={label}
      styles={{
        circle: {
          borderWidth: '4px',
          borderTopColor: 'black',
          borderBottomColor: 'lightgray',
          borderLeftColor: 'lightgray',
          borderRightColor: 'lightgray',
          width: '32px',
          height: '32px'
        },
        label: {
          color: '#333'
        }
      }}
    />
  );
}
